import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';

const css = ".ispui-select-search{display:block}.ispui-select-search[hidden]{display:none}.ispui-select-search_input{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:var(--ispui-select-search__height, 30px);padding:var(--ispui-select-search__padding, 0 8px);border:var(--ispui-select-search__border, 1px solid var(--isp-border-default));border-radius:var(--ispui-select-search__br, 3px);outline:none}";

const SearchDefault = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.search = createEvent(this, "search", 7);
    /** search value */
    this.value = '';
  }
  updateValue(newVal) {
    this.search.emit(newVal);
  }
  async focusInput() {
    this.input.focus();
  }
  render() {
    return (h(Host, { class: { 'ispui-select-search': true } }, h("input", { ref: (el) => (this.input = el), value: this.value, class: "ispui-select-search_input", type: "text", onInput: (e) => (this.value = e.target.value) })));
  }
  static get watchers() { return {
    "value": ["updateValue"]
  }; }
  static get style() { return css; }
}, [0, "ispui-select-search", {
    "value": [1025],
    "focusInput": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-select-search"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-select-search":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, SearchDefault);
      }
      break;
  } });
}

const IspuiSelectSearch = SearchDefault;
const defineCustomElement = defineCustomElement$1;

export { IspuiSelectSearch, defineCustomElement };
